export const barColors = ['#1B4DFF', '#76A2F6', '#F1DEEA']
